import { Controller } from "@hotwired/stimulus"

// Polls for background discovery job status and shows spinner/result.
// Connects to: _tests.html.erb, _endpoints.html.erb
export default class extends Controller {
  static values = {
    url: String,
    type: String,
    active: Boolean
  }

  static targets = ["button", "spinner", "result"]

  connect() {
    if (this.activeValue) {
      this.startPolling()
    }
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    this.buttonTarget.classList.add("hidden")
    this.spinnerTarget.classList.remove("hidden")
    this.poll()
    this.interval = setInterval(() => this.poll(), 3000)
  }

  stopPolling() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { "Accept": "application/json" }
      })
      if (!response.ok) return

      const data = await response.json()
      const status = data[this.typeValue]

      if (!status) return

      if (status.status === "completed") {
        this.stopPolling()
        this.showResult(status.result)
        setTimeout(() => location.reload(), 2000)
      } else if (status.status === "failed") {
        this.stopPolling()
        this.showError(status.error)
      }
    } catch {
      // Silently retry on next interval
    }
  }

  showResult(result) {
    this.spinnerTarget.classList.add("hidden")
    this.resultTarget.classList.remove("hidden")

    let message
    if (this.typeValue === "test_cases") {
      const matched = result?.matched ?? 0
      message = `Found ${matched} matching test case${matched !== 1 ? "s" : ""}. Refreshing...`
    } else if (this.typeValue === "flow") {
      const slug = result?.flow_slug
      message = slug
        ? `Flow generated! Redirecting...`
        : `Flow generated. Refreshing...`
      this.resultTarget.textContent = message
      this.resultTarget.style.color = "var(--success)"
      if (slug) {
        setTimeout(() => window.location.href = `/flows/${slug}`, 1500)
        return
      }
      return
    } else {
      const discovered = result?.discovered ?? 0
      message = `Discovered ${discovered} endpoint${discovered !== 1 ? "s" : ""}. Refreshing...`
    }

    this.resultTarget.textContent = message
    this.resultTarget.style.color = "var(--success)"
  }

  showError(error) {
    this.spinnerTarget.classList.add("hidden")
    this.resultTarget.classList.remove("hidden")
    this.resultTarget.textContent = error || "Discovery failed"
    this.resultTarget.style.color = "var(--danger)"

    // Restore button after 5s so user can retry
    setTimeout(() => {
      this.resultTarget.classList.add("hidden")
      this.buttonTarget.classList.remove("hidden")
    }, 5000)
  }
}
